/*
 * FLP kit buy box (sections/flp-buybox.liquid): CTA -> cart -> checkout.
 *
 * Config: the box root carries data-flp-cfg='{ offerKey, checkout, p3, p1, gifts[] }' (deliberately
 * NOT data-uo-cfg, so assets/lp-utc-offer-gifts.js never reads or caches this box).
 *
 * 3-month CTA: clear earlier gift lines of THIS offer key, then ONE /cart/add.js call with the
 * 3 Pack on its 3-month plan (_offer=<key>) plus every gift (qty 1, _gift=<key>, _gift_kind), so
 * gifts never exist without their anchor. Then straight to checkout (same as the UTC landers).
 * 1-month CTA: 1 Pack (plan or one-time per config), then checkout.
 * Free-ness of gifts is applied at checkout by the Semaine Checkout Rules app, never here.
 * See docs/lp-structures/founder-love-story.md
 */
(function () {
  'use strict';
  if (window.FLPOffer) return;

  var FALLBACK = 'Sorry, that could not be added. Please try again.';

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().catch(function () { return null; }).then(function (data) {
        if (!res.ok) {
          var err = new Error(url + ' ' + res.status);
          err.description = data && (data.description || data.message);
          throw err;
        }
        return data;
      });
    });
  }

  function readCfg(root) {
    try { return JSON.parse(root.getAttribute('data-flp-cfg')); } catch (e) { return null; }
  }

  function items(cfg, plan) {
    var key = cfg.offerKey;
    if (plan === '3') {
      var p3 = cfg.p3;
      if (!p3 || !p3.ok) return null;
      var list = [{ id: p3.variant, quantity: 1, selling_plan: p3.plan, properties: { _offer: key } }];
      (cfg.gifts || []).forEach(function (g) {
        if (g && g.variant) list.push({ id: g.variant, quantity: 1, properties: { _gift: key, _gift_kind: g.kind || 'gift' } });
      });
      return list;
    }
    var p1 = cfg.p1;
    if (!p1 || !p1.ok) return null;
    var one = { id: p1.variant, quantity: 1, properties: { _offer: key } };
    if (p1.plan) one.selling_plan = p1.plan;
    return [one];
  }

  function setMsg(btn, text) {
    var card = btn.closest('.offer-content') || btn.parentNode;
    var el = card ? card.querySelector('[data-flp-msg]') : null;
    if (!el) return;
    el.textContent = text || '';
    el.hidden = !text;
  }

  function track(plan) {
    if (typeof window.fireEvent === 'function') {
      try { window.fireEvent('lp_flp_cta', { plan: plan }); } catch (e) { /* analytics optional */ }
    }
  }

  function add(btn) {
    var root = btn.closest('[data-flp-cfg]');
    var cfg = root ? readCfg(root) : null;
    var plan = btn.getAttribute('data-flp-add') === '3' ? '3' : '1';
    if (!cfg) { setMsg(btn, FALLBACK); return; }
    var list = items(cfg, plan);
    if (!list) { setMsg(btn, 'Sorry, that option is unavailable right now. Please refresh and try again.'); return; }
    if (btn.getAttribute('aria-busy') === 'true') return;
    btn.setAttribute('aria-busy', 'true');
    btn.disabled = true;
    setMsg(btn, '');
    track(plan);
    var key = cfg.offerKey;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        // never duplicate this offer's gifts: clear earlier ones before the atomic add
        var updates = {};
        var any = false;
        (cart.items || []).forEach(function (it) {
          if (it.properties && it.properties._gift === key) { updates[it.key] = 0; any = true; }
        });
        return any ? post('/cart/update.js', { updates: updates }) : null;
      })
      .then(function () { return post('/cart/add.js', { items: list }); })
      .then(function () {
        // keep the busy state through the redirect
        setTimeout(function () { window.location.href = cfg.checkout || '/checkout'; }, 150);
      })
      .catch(function (e) {
        btn.removeAttribute('aria-busy');
        btn.disabled = false;
        setMsg(btn, (e && e.description) || FALLBACK);
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-flp-add]') : null;
    if (!btn) return;
    e.preventDefault();
    add(btn);
  });

  window.FLPOffer = { version: 1, add: add };
})();
